<template>
  <section ref="section">
    <div id="data-holder" ref="scrollRef">
      <div class="container">

        <div class="row data-grid">

          <div class="col-12 col-md-4 py-1 data-container">
            <div class="card data-box position-relative align-items-center justify-content-center">
              <!-- <span class="custom-margin"><i class="bi icon bi-person-fill"></i></span> -->
              <!-- <span class="counter-data"> {{ anosExperienciaCounter.toFixed(0) }}</span> -->
              <span class="counter-data"> +20 </span>
              <span class="data-text">Anos de experiência</span>
            </div>
          </div>
          
          <div class="col-12 col-md-4 py-1 data-container">
            <div class="card data-box align-items-center position-relative justify-content-center">
              <!-- <span class="custom-margin"><i class="bi bi-heart-fill"></i></span> -->
              <!-- <span class="counter-data">+{{ clientsCounter.toFixed(0) }}</span> -->
              <span class="counter-data">+500</span>
              <span class="data-text">clientes satisfeitos</span>
            </div>
          </div>

          <div class="col-12 col-md-4 py-1 data-container">
            <div class="card data-box align-items-center justify-content-center">
              <!-- <span class="custom-margin"><i class="bi icon bi-person-plus-fill"></i></span> -->
              <!-- <span class="counter-data">+{{ usersRegistered.toFixed(0) }}</span> -->
              <span class="counter-data">+5000</span>
              <span class="data-text">usuários registrados</span>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
</template>

<script>
// import gsap from 'gsap'
// import { ref } from "vue";
// import { useIntersectionObserver } from '@vueuse/core'
// import { getCurrentInstance } from 'vue'

export default {
  name: 'SectionData',
  components: {
  },
  data () {
    return {
      // number: 0,
      // anosExperienciaCounter: 0,
      // clientsCounter: 0,
      // usersRegistered: 0,
    }
  },
  mounted () {
    // function animate() {
      // gsap.to(this, { duration: 2, anosExperienciaCounter: Number(20) || 0 })
      // gsap.to(this, { duration: 3, usersRegistered: Number(4000) || 0 })
      // gsap.to(this, { duration: 3, clientsCounter: Number(500) || 0 })
    // }
  },
  // setup() {
  //   const app = getCurrentInstance()
  //   console.log(app)

  //   number = 0
  //   anosExperienciaCounter = 0
  //   clientsCounter = 0
  //   usersRegistered = 0

  //   const section = ref(null)
  //   const targetIsVisible = ref(false)
  //   const doAnimation = () => {
  //     gsap.to(app, { duration: 2, anosExperienciaCounter: Number(20) || 0 })
  //     gsap.to(app, { duration: 3, usersRegistered: Number(4000) || 0 })
  //     gsap.to(app, { duration: 3, clientsCounter: Number(500) || 0 })
  //   }
  //   const stop = useIntersectionObserver(
  //     section,
  //     ([{ isIntersecting }]) => {
  //       doAnimation();
  //       targetIsVisible.value = isIntersecting
  //     },
  //   )

  //   return {
  //     section,
  //     stop,
  //     number,
  //     anosExperienciaCounter,
  //     clientsCounter,
  //     usersRegistered,
  //     targetIsVisible,
  //   }
  // },
}
</script>

<style scoped>

.counter-data {
  font-size: 3rem;
  line-height: 51px;
  z-index: 1;
  filter: drop-shadow(3px 3px rgba(122, 121, 121, 0.575));
  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.custom-margin {
  margin-top: -30px;
}

.icon {
  font-size: 50px;
  margin-top: -30px;

  filter: drop-shadow(1.5px 1.5px rgba(122, 121, 121, 0.575));
  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-color: black;
  background-clip: text;
  -webkit-text-fill-color: transparent;  
}

.card {
  background-color: rgba(255, 255, 255, 0.74);
  font-family: Montserrat Bold;
  border-radius: 50px;
}

.data-box {
  height: 220px;
}

.data-year-box {
  min-height: 280px;
  position: relative;
  overflow: hidden;
}

.data-text {
  font-size: 1.3rem;
  text-align: center;

  filter: drop-shadow(1.5px 1.5px rgba(122, 121, 121, 0.575));
  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;  
}

#years-experience-icon {
  position: absolute;
  color: rgba(197, 197, 197, 0.767);

  top: -42px;
  right: 159px;
}

#registered-users-icon {
  position: absolute;
  color: rgba(197, 197, 197, 0.767);

  top: -42px;
  right: 159px;
}

.top-card {
  padding-bottom: .10rem;
}

.bottom-card {
  padding-top: .10rem;
}

#counter-years {
  font-size: 6rem;
  text-align: center;
  z-index: 1;

  filter: drop-shadow(3px 3px rgba(122, 121, 121, 0.575));
  background: linear-gradient(to right, #4258B1 30%, #EB5429 70%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

#years-text {
  font-size: 2rem;
  text-align: center;
  z-index: 1;

  filter: drop-shadow(3px 3px rgba(122, 121, 121, 0.575));
  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;   
}

#data-holder {
  padding: 90px 0;

  background: linear-gradient(138deg, rgba(92,107,167,1) 0%, rgba(251,113,73,1) 100%); 
  -webkit-text-fill-color: transparent;
}

.data-grid {
  margin: 0 7%;
}

@media (max-width: 992px) {
  .data-year-box {
    height: 280px;
  }
}

@media (max-width: 1200px) {
  #years-experience-icon {
    top: -30px;
    right: 100px;
  }
}

@media (max-width: 992px) {
  #years-experience-icon {
    top: -40px;
    left: -100px;
  }
}

</style>